import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchItemById } from "../../services/apiServices";
import {
  Button,
  Spinner,
  Alert,
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { toast } from "react-toastify";

const ViewItem = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const getItem = async () => {
      try {
        setLoading(true);
        const response = await fetchItemById(id);
        if (response.status && response.data) {
          setItem(response.data);
        } else {
          setError("Failed to fetch item details");
          toast.error("Failed to fetch item details");
        }
      } catch (err) {
        console.error(err);
        setError("Failed to fetch item details");
        toast.error("Failed to fetch item details");
      } finally {
        setLoading(false);
      }
    };
    getItem();
  }, [id]);

  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return (
      date.toLocaleDateString() +
      " " +
      date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    );
  };

  if (loading) {
    return (
      <Container className="text-center p-5">
        <Spinner color="primary" />
        <p className="mt-2">Loading item details...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Alert color="danger">{error}</Alert>
      </Container>
    );
  }

  if (!item) {
    return (
      <Container>
        <Alert color="warning">Item not found</Alert>
      </Container>
    );
  }

  return (
    <Container className="page-content">
      <Row>
        <Col lg={8} className="mx-auto">
          <Card>
            <CardHeader className="bg-primary text-white">
              <h5 className="mb-0">{item.name}</h5>
            </CardHeader>
            <CardBody>
              <Row>
                <Col md={4} className="text-center mb-3">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="img-fluid rounded"
                    style={{ maxHeight: "200px", objectFit: "contain" }}
                  />
                  <h4 className="fw-bold mt-2">
                    {formatCurrency(item.amount)}
                  </h4>
                </Col>
                <Col md={8}>
                  <p>
                    <strong>Item ID:</strong>{" "}
                    <span className="font-monospace">{item._id}</span>
                  </p>
                  <p>
                    <strong>Created:</strong> {formatDate(item.createdAt)}
                  </p>
                  <p>
                    <strong>Updated:</strong> {formatDate(item.updatedAt)}
                  </p>
                  <div className="border rounded p-3 bg-light">
                    <strong>Description:</strong>
                    <p className="mt-1">{item.description}</p>
                  </div>
                  <Button
                    color="secondary"
                    className="mt-3"
                    onClick={() => navigate(-1)}>
                    Back
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ViewItem;
